<template>
  <div class="queued-sidebar">
    <div  v-if="isFreeUser">
      <queue-complete v-if="currentJob.state === 'completed'"></queue-complete>
      <queue-failed v-if="currentJob.state === 'failed'"></queue-failed>
      <queue-zip v-if="currentJob.state === 'zip'"></queue-zip>
      <queue-not-found v-if="currentJob.state === 'not_found'"></queue-not-found>
      <queue-cancelled v-if="currentJob.state === 'cancelled'"></queue-cancelled>
      <queue-protected v-if="currentJob.state === 'unauthorized'"></queue-protected>
      <div v-if="currentJob.state === 'processing'">
        <queue-prepare v-if="currentJob.apiJob === null  && currentJob.state !== 'not_found'"></queue-prepare>
        <queue-processing v-if="currentJob.apiJob !== null && currentJob.state === 'processing' && currentJob.apiJob?.sat?.queue?.status !== 'queued'" ></queue-processing>
        <queue-generic v-if="currentJob.apiJob?.sat?.queue?.status === 'queued' && currentJob.apiJob?.sat.queue.ahead < 2"></queue-generic>
        <queue-place-in-queue v-if="currentJob.apiJob?.sat?.queue?.ahead && currentJob.apiJob?.sat?.queue?.status === 'queued'  && currentJob.apiJob?.sat.queue.ahead >= 2"></queue-place-in-queue>
      </div>
    </div>
    <div  v-if="!isFreeUser">
      <queue-prepare v-if="currentJob.apiJob === null  && currentJob.state !== 'not_found'"></queue-prepare>
      <queue-processing v-if="currentJob.apiJob !== null && currentJob.state === 'processing'"></queue-processing>
      <queue-zip v-if="currentJob.state === 'zip'"></queue-zip>
      <queue-not-found v-if="currentJob.state === 'not_found'"></queue-not-found>
      <queue-complete v-if="currentJob.state === 'completed'"></queue-complete>
      <queue-failed v-if="currentJob.state === 'failed'"></queue-failed>
      <queue-cancelled v-if="currentJob.state === 'cancelled'"></queue-cancelled>
      <queue-protected v-if="currentJob.state === 'unauthorized'"></queue-protected>
    </div>
    <div v-if="currentJob.apiJob?.warnings[0]?.code === 666">
      <queue-n-s-f-w></queue-n-s-f-w>
    </div>
  </div>
</template>
<script>
import store from './../../mixins/store.mixin'
import currentJob from './../../mixins/current_job.mixin'
import QueueGeneric from "./QueueState/QueueGeneric.vue";
import QueueProcessing from "./QueueState/QueueProcessing.vue";
import QueuePlaceInQueue from "./QueueState/QueuePlaceInQueue.vue";
import QueueFailed from "./QueueState/QueueFailed.vue";
import QueueComplete from "./QueueState/QueueComplete.vue";
import user from "../../mixins/user.mixin";
import QueuePrepare from "./QueueState/QueuePrepare.vue";
import QueueNSFW from "./QueueState/QueueNSFW.vue";
import QueueZip from "./QueueState/QueueZip.vue";
import QueueNotFound from "./QueueState/QueueNotFound.vue";
import QueueCancelled from "./QueueState/QueueCancelled.vue";
import QueueProtected from './QueueState/QueueProtected.vue';

export default {
  name: "JobQueued",
  props: {},
  components: {
    QueueCancelled,
    QueueNotFound,
    QueueZip,
    QueueNSFW, QueuePrepare, QueueComplete, QueueFailed, QueuePlaceInQueue, QueueProcessing, QueueGeneric, QueueProtected},
  mixins: [
    store,
    currentJob,
    user,
  ],
  data() {
    return {
    };
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {
  },
  computed: {}
};
</script>
<style lang="scss">
.queue-queued {
  border: 1px solid #8F6C25;
  h2 {
    color: #8F6C25;
  }
  .queue-icon {
    color: #8F6C25;
    border: 2px solid #8F6C25;
    border-right-color: transparent;
  }
  background: #FFF1D6;
  color: #8F6C25;
}

.queue-processing {
  border: 1px solid #2D5089;
  h2 {
    color: #2D5089;
  }
  .queue-icon {
    color: #2D5089;
    border: 2px solid #2D5089;
    border-right-color: transparent;
  }
  background: #D9E7FD;
  color: #2D5089;
}

.queue-failed {
  border: 1px solid #8F2E2E;
  h2 {
    color: #8F2E2E;
  }
  background: #FFDADA;
  color: #8F2E2E;
}

.queue-complete {
  border: 1px solid #0B7335;
  h2 {
    color: #0B7335;
  }
  background: #CCF4DC;
  color: #0B7335;
}

.queued-sidebar {
  .priority-item {
    padding: 20px;
    border-radius: 9px;
  }
  border-radius: 9px;
  .queue-btn  {
    display: inline-flex;
    gap: 10px;
    align-items:center;
  }
  .priority-item {
    display:flex;
    flex-direction: column;
    gap: 10px;
  }
  p {
    margin: 0;
  }
  h2 {
    margin: 0;
    font-size: 1.25em;
  }
}
</style>
